import script from "./Name+DBA+Description+CustomerNotes+PlatformNotes+PC+INV+MgrNotes.vue?vue&type=script&setup=true&lang=js"
export * from "./Name+DBA+Description+CustomerNotes+PlatformNotes+PC+INV+MgrNotes.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__